import { createFileRoute, notFound } from '@tanstack/react-router';

import { RoleGuardLayout } from './-role-guard.layout';

const ACCEPTED_BLOOD_ROLES = ['staff', 'admin'];

const BLOOD_REPORT_INDEX_PATH = '/blood-report';

export const Route = createFileRoute('/blood-report/_role-guard')({
  beforeLoad: ({
    context: {
      user: { roles },
    },
    location,
  }) => {
    const pathname = location.pathname;

    if (pathname === BLOOD_REPORT_INDEX_PATH || pathname === `${BLOOD_REPORT_INDEX_PATH}/`) {
      throw notFound();
    }

    const hasValidRole = ACCEPTED_BLOOD_ROLES.some((role) => roles.includes(role));

    return { hasValidRole };
  },
  component: RoleGuardLayout,
});
